export enum AbregelungFREAnwenderadresse {
    B0A0 = 'B0A0',
    B0A1 = 'B0A1',
    B0A2 = 'B0A2',
    B0A3 = 'B0A3',
    B0A4 = 'B0A4',
    B0A5 = 'B0A5',
    B0A6 = 'B0A6',
    B0B1 = 'B0B1',
    B1A4 = 'B1A4',
    BFB1 = 'BFB1',
    BFB2 = 'BFB2',
    B1A2 = 'B1A2',
}
